import { render, staticRenderFns } from "./arrayNumber.vue?vue&type=template&id=684381b2&scoped=true&"
import script from "./arrayNumber.vue?vue&type=script&lang=js&"
export * from "./arrayNumber.vue?vue&type=script&lang=js&"
import style0 from "./arrayNumber.vue?vue&type=style&index=0&id=684381b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684381b2",
  null
  
)

export default component.exports